import { ScreenContainerRef } from '../../../context'

function RequestProfileScreenContainer({
  children,
  isPreview,
  scrollWrapperRef,
}) {
  return isPreview ? (
    <ScreenContainerRef value={scrollWrapperRef}>{children}</ScreenContainerRef>
  ) : (
    children
  )
}

export default RequestProfileScreenContainer
